import Vue from 'vue';
import Vuex from 'vuex';
import dataManage from './dataManage'
import system from './system'
import analysis from './analysis'
import lEtl from './l-etl'
import largeDatabase from './largeDatabase'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    envMark: process.env.NODE_ENV == 'ds',//大赛环境标记
    devMark: process.env.NODE_ENV == 'sx',//开发中功能标记（实训环境隐藏）
    // devMark: process.env.NODE_ENV == 'development',
  },
  modules: {
    system,
    dataManage,
    lEtl,
    largeDatabase,
    analysis
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'vuex-data',
      paths: ['system', 'dataManage', 'lEtl', 'largeDatabase', 'analysis']
    })
  ]
});

export default store;




// WEBPACK FOOTER //
// ./src/store/index.js